import React from 'react';
import T from '../components/T';

export default class Images extends React.Component {
  handleImageUpload = (e) => {
    e.preventDefault();

    const reader = new FileReader();
    const file = e.target.files[0];

    reader.onloadend = () => {
      const { addImage } = this.props;
      addImage(reader.result);
    };

    reader.readAsDataURL(file);
  };

  render() {
    const { fieldState, images, onInputChange, name, allowAuthorToUploadCustomImages } = this.props;

    return [
      <div className="c-input__wrapper" key={1}>
        <span className="c-input__label">
          <T msg="campaignEditor.form.labels.images" />
        </span>
        <div className="photo__wrapper">
          {images.map((image, i) => (
            <Image
              key={i}
              name={name}
              imageId={image.id}
              src={image.url}
              fieldState={fieldState}
              onInputChange={onInputChange}
            />
          ))}
        </div>
      </div>,

      allowAuthorToUploadCustomImages ?
      <label className="campaign-edit__button campaign-edit__button--photo c-button" key={2}>
        <span className="c-button__content">
          <T msg="campaignEditor.form.labels.uploadCustomImage" />
        </span>
        <input
          style={{
            width: 0.1,
            height: 0.1,
            position: 'absolute',
            opacity: 0,
            zIndex: -1,
            overflow: 'hidden'
          }}
          type="file"
          accept=".png, .jpg, .jpeg"
          onChange={this.handleImageUpload}
        />
      </label> : null
    ];
  }
}

// eslint-disable-next-line react/no-multi-comp
class Image extends React.PureComponent {
  render() {
    const { name, imageId, src, fieldState, onInputChange } = this.props;

    return (
      <label className="photo">
        <input
          type="radio"
          name={name}
          value={imageId}
          className="photo__input"
          onChange={onInputChange}
          checked={fieldState.getValue() === imageId || fieldState.getValue() === src}
          readOnly
        />
        <img src={src} className="photo__img" />
      </label>
    );
  }
}



// WEBPACK FOOTER //
// ./app/Assets/js/features/campaignEditor/Images.js